var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTabScanFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_57429",
    fill: "current",
    "data-name": "Group 57429",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23.001,
    height: 20.786,
    viewBox: "0 0 23.001 20.786",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7019",
    "data-name": "Rectangle 7019",
    width: 23.001,
    height: 20.786,
    fill: "inherit"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tab_scan_icon",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_155523",
    "data-name": "Path 155523",
    d: "M4.45,37.211v-.354c0-1.168,0-2.336,0-3.5a2.369,2.369,0,0,1,2.5-2.5q4.541,0,9.083,0a2.368,2.368,0,0,1,2.509,2.5c0,1.1,0,2.193,0,3.289v.338h.331c1.006,0,2.014.035,3.018-.012a1.176,1.176,0,0,1,1.064,1.477.932.932,0,0,1-.867.654c-.09.006-.18,0-.27,0H1.124c-.09,0-.18,0-.269,0A.858.858,0,0,1,0,38.124a.9.9,0,0,1,.907-.909c1.069-.009,2.138,0,3.207,0H4.45",
    transform: "translate(0.001 -27.522)",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155524",
    "data-name": "Path 155524",
    d: "M41.328,120.516h14.02a20.2,20.2,0,0,1-.022,2.59,2.23,2.23,0,0,1-2.229,1.865q-4.745.021-9.49,0a2.283,2.283,0,0,1-2.268-2.109c-.057-.775-.011-1.557-.011-2.345",
    transform: "translate(-36.855 -107.52)",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155525",
    "data-name": "Path 155525",
    d: "M143.735,0a13.231,13.231,0,0,1,1.794.125A3.236,3.236,0,0,1,148.1,3.3c.021.781.013,1.563,0,2.344a.864.864,0,0,1-.955.978.915.915,0,0,1-.919-1.007c0-.71,0-1.419,0-2.129a1.437,1.437,0,0,0-1.554-1.564c-.736,0-1.473.007-2.209,0a.91.91,0,0,1-.924-.809.917.917,0,0,1,.716-1.048,1.343,1.343,0,0,1,.294-.025c.4,0,.79,0,1.185,0,0-.012,0-.023,0-.035",
    transform: "translate(-126.269)",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155526",
    "data-name": "Path 155526",
    d: "M15.081,137.854a13.061,13.061,0,0,1-1.793-.129,3.228,3.228,0,0,1-2.56-3.153c-.024-.79-.017-1.581,0-2.371a.933.933,0,0,1,1.35-.882.9.9,0,0,1,.523.872c0,.728,0,1.455,0,2.183a1.438,1.438,0,0,0,1.56,1.558c.7,0,1.4,0,2.1,0a.947.947,0,1,1,.007,1.886c-.4,0-.79,0-1.185,0l0,.036",
    transform: "translate(-9.556 -117.068)",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155527",
    "data-name": "Path 155527",
    d: "M148.135,133.62a14.494,14.494,0,0,1-.125,1.714,3.238,3.238,0,0,1-3.121,2.6c-.808.012-1.616.007-2.424,0a.852.852,0,0,1-.936-.912.911.911,0,0,1,.932-.969c.754-.012,1.508,0,2.263,0a1.425,1.425,0,0,0,1.5-1.485c.006-.728,0-1.455,0-2.183a.921.921,0,0,1,.921-1.031,1,1,0,0,1,.955,1.031c.006.413,0,.826,0,1.24l.034,0",
    transform: "translate(-126.267 -117.183)",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155528",
    "data-name": "Path 155528",
    d: "M15.157.312c.4,0,.808,0,1.212,0a.916.916,0,0,1,.963.939.917.917,0,0,1-.959.945c-.754.009-1.509,0-2.263,0a1.421,1.421,0,0,0-1.47,1.458c-.009.737,0,1.473,0,2.21A.922.922,0,0,1,11.715,6.9a1,1,0,0,1-.953-1.032c0-.862-.03-1.727.032-2.585A3.338,3.338,0,0,1,14,.313c.386-.005.772,0,1.159,0",
    transform: "translate(-9.595 -0.277)",
    fill: "inherit"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabScanFill);
export default __webpack_public_path__ + "static/media/tab-scan-fill.be9a0eaa5e00b660fe7176b3ad91a1fc.svg";
export { ForwardRef as ReactComponent };